/**
* Logo Mark Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Mark Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
import {max} from '@splidejs/splide/src/js/utils';
( function( app ) {
  const COMPONENT = {

    className: 'logo-mark-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-mark-marquee' ).each( function() {
        const $section = $( this );
        const $list = $section.find( '.splide__list' );
        const $originalSlides = $list.find( '.splide__slide' );
        const doubleSectionWidth = $section.width() * 2;
        let totalWidth = 0;
        let iterations = 0;
        const maxIterations = 10;
        $originalSlides.each( function() {
          totalWidth += $( this ).outerWidth( true );
        } );
        while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
          $originalSlides.each( function() {
            $list.append( $( this ).clone() );
            totalWidth += $( this ).outerWidth( true );
          } );
          iterations++;
        }
      } );
      new Splide( '.splide--logo-mark-marquee', {
        type: 'loop',
        arrows: false,
        pagination: false,
        autoWidth: true,
        gap: '24px',
        autoScroll: {
          speed: 0.5,
        },
      } ).mount( {AutoScroll} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-mark-marquee', COMPONENT );
} )( app );
